/* tslint:disable */
/* eslint-disable */
/**
 * Hermes Console
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 請求金額
 * @export
 * @interface DriverPaymentsSummaryRow
 */
export interface DriverPaymentsSummaryRow {
    /**
     * 乗務員ID
     * @type {number}
     * @memberof DriverPaymentsSummaryRow
     */
    driverId?: number;
    /**
     * 乗務員番号
     * @type {string}
     * @memberof DriverPaymentsSummaryRow
     */
    driverCode?: string;
    /**
     * 乗務員名
     * @type {string}
     * @memberof DriverPaymentsSummaryRow
     */
    driverName?: string;
    /**
     * 課金対象Trip数
     * @type {number}
     * @memberof DriverPaymentsSummaryRow
     */
    nChargeableTrips?: number;
    /**
     * 金額
     * @type {number}
     * @memberof DriverPaymentsSummaryRow
     */
    price?: number;
}

export function DriverPaymentsSummaryRowFromJSON(json: any): DriverPaymentsSummaryRow {
    return DriverPaymentsSummaryRowFromJSONTyped(json, false);
}

export function DriverPaymentsSummaryRowFromJSONTyped(json: any, ignoreDiscriminator: boolean): DriverPaymentsSummaryRow {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'driverId': !exists(json, 'driver_id') ? undefined : json['driver_id'],
        'driverCode': !exists(json, 'driver_code') ? undefined : json['driver_code'],
        'driverName': !exists(json, 'driver_name') ? undefined : json['driver_name'],
        'nChargeableTrips': !exists(json, 'n_chargeable_trips') ? undefined : json['n_chargeable_trips'],
        'price': !exists(json, 'price') ? undefined : json['price'],
    };
}

export function DriverPaymentsSummaryRowToJSON(value?: DriverPaymentsSummaryRow | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'driver_id': value.driverId,
        'driver_code': value.driverCode,
        'driver_name': value.driverName,
        'n_chargeable_trips': value.nChargeableTrips,
        'price': value.price,
    };
}


